import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../utils/config";
import { chGuardarSessio, chObtenirUuidTerminal, chNomTerminal, chTeSessio } from "./chAuth";
import { CH_ESTIL_FONS } from "./chEstil";
import "./controlhorari.css";

// Login propi de /Control_Horari (CURRENT_TASK.md §6): reutilitza el
// mecanisme d'autenticació (Usuari + contrasenya de l'ERP) però és un
// backend/flux propi (ControlHorariLogin.php), no login.php.
function ControlHorariLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [enviant, setEnviant] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Si ja hi ha una sessió (encara que hagi de renovar-se), no cal tornar
  // a demanar credencials: que ho intenti la pantalla d'Inici.
  useEffect(() => {
    if (chTeSessio()) {
      navigate("/Control_Horari/avui", { replace: true });
    }
  }, [navigate]);

  if (chTeSessio()) {
    return null;
  }

  const gestionarEnviament = async (e) => {
    e.preventDefault();
    if (enviant) return;
    setError("");
    setEnviant(true);
    try {
      const resposta = await fetch(`${API_URL}/ControlHorariLogin.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username,
          password,
          uuidTerminal: chObtenirUuidTerminal(),
          nomTerminal: chNomTerminal(),
        }),
      });
      const dades = await resposta.json();

      if (!dades.success) {
        setError(dades.message || "No s'ha pogut iniciar sessió.");
        setEnviant(false);
        return;
      }

      chGuardarSessio({
        accessToken: dades.accessToken,
        refreshToken: dades.refreshToken,
        empleat: dades.empleat,
      });
      navigate("/Control_Horari/avui", { replace: true });
    } catch (err) {
      setError("No s'ha pogut connectar amb el servidor. Comprova la connexió.");
      setEnviant(false);
    }
  };

  return (
    <div className="ch-app ch-login-pantalla" style={CH_ESTIL_FONS}>
      <div className="ch-login-caixa">
        <img src="/images/controlhorari/logo-punt.png" alt="" className="ch-login-logo" />
        <h1 className="ch-login-titol">Control Horari</h1>
        <p className="ch-login-subtitol">Inicia sessió per fitxar</p>

        <form onSubmit={gestionarEnviament} className="ch-login-form" autoComplete="off">
          {error && <div className="ch-avis-error">{error}</div>}

          <label className="ch-camp">
            <span>Nom d'usuari</span>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
              disabled={enviant}
            />
          </label>

          <label className="ch-camp">
            <span>Contrasenya</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              disabled={enviant}
            />
          </label>

          <button type="submit" className="ch-boto-principal ch-boto-blau" disabled={enviant}>
            {enviant ? "Entrant..." : "Entrar"}
          </button>
        </form>

        <p className="ch-login-nota">Cal connexió a Internet per al primer accés des d'aquest dispositiu.</p>
      </div>
    </div>
  );
}

export default ControlHorariLogin;
